$(function(){
    function mrk_cart_code(){
      $('.ProductPopup-mrk-pop').click(function(){
        $('#mrk-form').trigger("reset");
        var form_to_update = $('#mrk-form');
        var curr_form = $(this).parents('.cart-item');
        var qty = curr_form.find('.quantity__input').val();
        var var_id = curr_form.attr('key');
        var id = curr_form.attr('mrk_id');
        var text_1 = curr_form.attr('text1');
        var text_2 = curr_form.attr('text2');
        form_to_update.find('[name="id"]').val(id);
        form_to_update.find('[name="quantity"]').val(qty);
        form_to_update.find('.update_customization').attr('to_remove', var_id);
        if(text_1 != ''){
            $('#show_front_text').prop('checked', true);
            $('#front-side-text').val(text_1);
        }
        if(text_2 != ''){
            $('#show_back_text').prop('checked', true);
            $('#Back-side-text').val(text_2);
        }
        
        $('#PopupModal-mrk-pop').addClass('form-active');
    });
    }
    $("#front-image:file").on("change", function (e) {
            if(this.files[0])
          $('.image-name-1').html(this.files[0].name);
            else
          $('.image-name-1').html('');
            var file_type = this.files[0].type;
          var image = this.files[0];
        if(image.size <5242879){
          $('.loader-1').html(`<div class="Loading"></div>`);
            console.log(image);
        if(file_type == 'application/pdf'){
          setTimeout(function () {
              var canvasElement = document.querySelector(".iframe-1")
              var file = image;
              if (file.type != "application/pdf") {
                  console.error(file.name, "is not a pdf file.")
                  return
              }
              var fileReader = new FileReader();
              fileReader.onload = function () {
                  var typedarray = new Uint8Array(this.result);
                  PDFJS.getDocument(typedarray).then(function (pdf) {
                      console.log("the pdf has ", pdf.numPages, "page(s).")
                      pdf.getPage(pdf.numPages).then(function (page) {
                          var viewport = page.getViewport(2.0);
                          var canvas = document.querySelector(".iframe-1");
                          canvas.height = viewport.height;
                          canvas.width = viewport.width;
                          page.render({
                              canvasContext: canvas.getContext('2d'),
                              viewport: viewport
                          });
                      });
                  });
              };
              fileReader.readAsArrayBuffer(file);
                $('.loader-1').html(``);
                $('.iframe-1').show();
                $('.placeholder-1').hide();
                $('.upload-1').addClass('mrk-image-added')
          },3500)
        }
        else if(file_type == 'application/postscript' || file_type == ''){
            setTimeout(function () {
              var reader = new FileReader();
              reader.onloadend = function () {
                  $('.iframe-1').hide();
                  if(file_type == 'application/postscript')
                    $('.placeholder-1').show().attr('src', "//cdn.shopify.com/s/files/1/0613/5919/4306/files/AI.png?v=6283552184397460155");
                  if(file_type == '')
                    $('.placeholder-1').show().attr('src', "//cdn.shopify.com/s/files/1/0613/5919/4306/files/PSD.png?v=11552293306837961472");
                  $('.placeholder-1').show();
              }
              reader.readAsDataURL(image);
              $('.loader-1').html(``);
          }, 3500);
        }
        else{
            setTimeout(function () {
              var reader = new FileReader();
              reader.onloadend = function () {
                  $('.iframe-1').hide();
                  $('.placeholder-1').show().attr('src', reader.result);
              }
              reader.readAsDataURL(image);
              $('.loader-1').html(``);
                $('.upload-1').addClass('mrk-image-added')
          }, 3500);
        }
        }
        else{
            alert('Excedded File Size');
          $(this).val('');
            $('#front-image').val('').trigger('change');
      }
      });
    $("#back-image:file").on("change", function (e) {
        
          if(this.files[0])
          $('.image-name-2').html(this.files[0].name);
            else
          $('.image-name-2').html('');
            var file_type = this.files[0].type;
          var image = this.files[0];
      if(image.size <5242879){
          $('.loader-2').html(`<div class="Loading"></div>`);
        if(file_type == 'application/pdf'){
          setTimeout(function () {
              var canvasElement = document.querySelector(".iframe-2")
              var file = image;
              if (file.type != "application/pdf") {
                  console.error(file.name, "is not a pdf file.")
                  return
              }
              var fileReader = new FileReader();
              fileReader.onload = function () {
                  var typedarray = new Uint8Array(this.result);
                  PDFJS.getDocument(typedarray).then(function (pdf) {
                      console.log("the pdf has ", pdf.numPages, "page(s).")
                      pdf.getPage(pdf.numPages).then(function (page) {
                          var viewport = page.getViewport(2.0);
                          var canvas = document.querySelector(".iframe-2");
                          canvas.height = viewport.height;
                          canvas.width = viewport.width;
                          page.render({
                              canvasContext: canvas.getContext('2d'),
                              viewport: viewport
                          });
                      });
                  });
              };
              fileReader.readAsArrayBuffer(file);
                $('.loader-2').html(``);
                $('.iframe-2').show();
                $('.placeholder-2').hide();
                $('.upload-2').addClass('mrk-image-added')
          },3500)
        }
        else if(file_type == 'application/postscript' || file_type == ''){
            setTimeout(function () {
              var reader = new FileReader();
              reader.onloadend = function () {
                  $('.iframe-2').hide();
                  if(file_type == 'application/postscript')
                    $('.placeholder-2').show().attr('src', "//cdn.shopify.com/s/files/1/0613/5919/4306/files/AI.png?v=6283552184397460155");
                  if(file_type == '')
                    $('.placeholder-2').show().attr('src', "//cdn.shopify.com/s/files/1/0613/5919/4306/files/PSD.png?v=11552293306837961472");
                  $('.placeholder-2').show();
              }
              reader.readAsDataURL(image);
              $('.loader-2').html(``);
          }, 3500);
        }
        else{
            setTimeout(function () {
              var reader = new FileReader();
              reader.onloadend = function () {
                  $('.iframe-2').hide();
                  $('.placeholder-2').show().attr('src', reader.result);
              }
              reader.readAsDataURL(image);
              $('.loader-2').html(``);
                $('.upload-2').addClass('mrk-image-added')
          }, 3500);
        }
      }else{
            alert('Excedded File Size');
          $(this).val('');
            $('#back-image').val('').trigger('change');
      }
      });
    $('#ModalClose-mrk-pop').click(function(){
        $('#PopupModal-mrk-pop').removeClass('form-active');
    });
    /* reorder code */
    $('.mrk-reorder-pop').click(function () {
        var to_show = $(this).attr('data-id');
        $(`#${to_show}`).addClass('form-active');
    });
    $('.mrk-reorder-close').click(function () {
        $('.mrk-reorder-pop-content').removeClass('form-active');
    });
    $('.row-remove').click(function(){
        if($(this).parents('.main-reorder').find('.mrk-flex-reorder').length == 1){
          alert('Minimum one product is required.')
          return;
        }
        $(this).parents('.mrk-flex-reorder').remove();
    });
    $('.mrk-variant-select').change(function(){
    var price = $(this).find('option:selected').attr('price');
    $(this).parents('.reorder-title').find('.reorder-product-price').text(price);
})
     /* reorder code */
    $('[name="back_type"]').change(function(){
        if($(this).val() == 'own'){
            $('.mrk-back-side-containder').removeClass('stander-back');
        }else{
            $('.mrk-back-side-containder').addClass('stander-back');
        }
    });
  $('.mrk-edit-product').each(function(){
    	$(this).click(function(){
        var form_to_update = $('#mrk-form');
        var curr_form = $(this).parents('.cart-item');
        var qty = curr_form.find('.quantity__input').val();
        var var_id = curr_form.attr('key');
        var id = curr_form.attr('mrk_id');
        form_to_update.find('[name="id"]').val(id);
        form_to_update.find('[name="quantity"]').val(qty);
        form_to_update.find('.update_customization').attr('to_remove', var_id);
        if($(this).attr('back-side') == 'no-backside'){
          $('.backside-side').hide();
        }else{
          $('.backside-side').show();
        }
        $('#PopupModal-mrk-pop').addClass('form-active');
    });
  });
    $('.update_customization').click(function(){
       if($('#front-image').val() != ''){
        $('#PopupModal-mrk-pop').removeClass('form-active');
        $('.mrk_loader').css('display','flex');
        var to_remove = $(this).attr('to_remove');
        jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
            updates: {
                [to_remove]: 0
            }
        }).then(function () {
            var data = document.querySelector('#PopupModal-mrk-pop form');
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
  
            const formData = new FormData(data);
            formData.append('sections_url', window.location.pathname);
            config.body = formData;
  
            fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                    if (response.status) {
                        return;
                    }
  
                    console.log('success', response);
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                          window.location.reload();
                });
        });
      }else{
            $('.upload-1').addClass('mrk-error');
            document.querySelector('.upload-1').scrollIntoView({behavior: "smooth"});
          setTimeout(function(){
            $('.upload-1').removeClass('mrk-error');
          },5000)
        }
    });
  mrk_cart_code();
updateCanvases();
  $('#main-cart-items').bind("DOMSubtreeModified", function() {
      mrk_cart_code();
  });
function updateCanvases(){
	$('[data_pdf]').each(function(){
    var canvas_data = $(this).attr('id');
    var spinner = $(this).parents('.mrk-canvas').find('.loading-overlay');
    var myState = {
      pdf: null,
      currentPage: 1,
      zoom: 1
    }
    PDFJS.getDocument($(this).attr('data_pdf')).then((pdf) => {
      myState.pdf = pdf;
      render();

    });

        function render() {
          myState.pdf.getPage(myState.currentPage).then((page) => {
            var canvas = document.getElementById(canvas_data);
            var ctx = canvas.getContext('2d');
            var viewport = page.getViewport(myState.zoom);
            canvas.width = viewport.width;
            canvas.height = viewport.height;
            page.render({
              canvasContext: ctx,
              viewport: viewport
            });
            setTimeout(function(){
            spinner.addClass('hidden');
            },3000)
            
          });
        }
    })
}
$('.submit_form').click(function () {
    var btn = $(this);
    var btn_text = btn.text();
    var products = [];
    var container = $(this).parents('.mrk-reorder-pop-content');
    container.find('.mrk-flex-reorder').each(function () {
        var id = $(this).find('[name="id"]').val();
        var qty = $(this).find('[name="quantity"]').val();
        var orderDate = $(container).attr('orderDate');;
        var orderNumber = $(container).attr('orderNumber');
        var product = {
            quantity: qty,
            id: id,
            properties: {
              'Order Date': orderDate,
              'Order Number': orderNumber
            }
        };
        products.push(product);
    });
    var data = {
        items: products
    };
    console.log(data);
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        beforeSend: function () {
            btn.text('Adding..');
            btn.addClass('disabled');
        },
        success: function () {
            btn.text('Added');
            if(btn.hasClass("checkout_add_to_cart"))
              window.location.href = '/checkout'
            setTimeout(function () {
                btn.text(btn_text);
                btn.removeClass('disabled');
            }, 2000);
        },
        error: function (e) {}
    });
})
  });